import type { BlockComponentType, BlockComponentStateId } from '../../types/block';
import type { enterKeyBehaviorEnum } from '../common/CommentMessageInputSchemas/schema';
import type { FileType } from '../FileUpload/types';
import type { MessageInputAction } from '../MessageInput/types';
import type { StackAppearance } from '../Stack/types';

type Content = {
  mode?: 'compact' | 'comfortable';
  enterKeyBehavior?: enterKeyBehaviorEnum;
  autoFocus?: boolean;
  placeholder?: string;
  actions: MessageInputAction[];
  linkedBlockId?: string;
};

export type Appearance = {
  disabled?: boolean;
  styles?: StackAppearance['styles'];
};

export type CopilotInputComponentType = BlockComponentType<'CopilotInput', Content, Appearance>;

export type CopilotInputBlockStateType = Pick<
  CopilotInputComponentType,
  'appearance' | 'componentType' | 'content'
> &
  BlockComponentStateId & {
    value: string | undefined;
    attachments?: FileType[];
    isUploadingAttachments?: boolean;
    modelId?: string;
    aiAgentId?: string;
    // uppy reference Id, used to upload files using this copilotInput from any other block using this referenceId
    referenceId?: string;
    webSearchEnabled?: boolean;
  };

export type CopilotInputBlockRef = {
  startDictation?: () => void;
  stopDictation?: () => void;
  reset?: () => void;
};

export type CopilotInputComputedBlockStateType = Pick<
  CopilotInputComponentType,
  'appearance' | 'componentType'
> & {
  content: Omit<Content, 'isSubmitDisabled'> & {
    isSubmitDisabled: boolean;
  };
} & BlockComponentStateId & {
    value: string | undefined;
    attachments?: FileType[];
    isUploadingAttachments?: boolean;
    modelId?: string;
    aiAgentId?: string;
    referenceId?: string;
    webSearchEnabled?: boolean;
  };

export enum CopilotInputMethods {
  SetValue = 'setValue',
  ChangeMode = 'changeMode',
  StartDictation = 'startDictation',
  StopDictation = 'stopDictation',
  Reset = 'reset',
}
